import React, { useState, useEffect } from "react";
import classes from "./style.module.css";
import Xarrow from "react-xarrows";
import MatchTestElement from "../../../../../assets/components/Match/MatchTestElement";
import TickSound from "../../../../../assets/Audio/clickSoundEffect.wav";

const Option = ({ id, text, onClick, color }) => (
  <MatchTestElement
    id={id}
    text={text}
    handleClick={() => onClick(id)}
    index={color}
    type={"connect"}
  />
);

export default function ConnnectContainer({ rightSide, leftSide, onConnect }) {
  const [lines, setLines] = useState([]);
  const [currentStartId, setCurrentStartId] = useState(null);
  const TickAudio = new Audio(TickSound);
  const soudMuted = JSON.parse(localStorage.getItem("soudMuted"));

  useEffect(() => {
    let linesCopy = [];
    if (lines.length > 0) {
      linesCopy = lines.map(
        (item) =>
          `${rightSide[item.start.match(/(\d+)/)[0]]}|${
            leftSide[item.end.match(/(\d+)/)[0]]
          }`
      );
      if (soudMuted) {
        TickAudio.play();
      }
    }

    onConnect(linesCopy);
  }, [lines]);

  const handleRightOptionClick = (id) => {
    const existingLineIndex = lines.findIndex((line) => line.start === id);
    if (existingLineIndex !== -1) {
      const updatedLines = [...lines];
      updatedLines.splice(existingLineIndex, 1);
      setLines(updatedLines);
    }
    setCurrentStartId(id);
  };

  const handleLeftOptionClick = (id) => {
    if (currentStartId) {
      setLines((prev) => [...prev, { start: currentStartId, end: id }]);
      setCurrentStartId(null);
    }
  };

  return (
    <div className={classes.connectContainer}>
      <div className={classes.sideContainer}>
        {rightSide.map((text, i) => (
          <Option
            key={i}
            id={`right-${i}`}
            text={text}
            onClick={handleRightOptionClick}
            color={0}
          />
        ))}
      </div>
      <div className={classes.sideContainer}>
        {leftSide.map((text, i) => (
          <Option
            key={i}
            id={`left-${i}`}
            text={text}
            onClick={handleLeftOptionClick}
            color={2}
          />
        ))}
      </div>
      {lines.map((line, index) => (
        <Xarrow
          key={index}
          start={line.start}
          end={line.end}
          color="#5DDFB2"
          strokeWidth={3}
          startAnchor="left"
          endAnchor="right"
          animateDrawing
        />
      ))}
    </div>
  );
}
